import React, { useEffect, useState } from "react";
import Loader from "../lib/components/Loader";

import api from '../utils/api';

const NUM_RESULTS_PER_PAGE = 20;
const getNumPages = (listLength) => Math.ceil(listLength / NUM_RESULTS_PER_PAGE);

const Pagination = ({ listLength, updatePageNumber }) => {
    const [pageNumber, setPageNumber] = useState(1);
    const numPages = getNumPages(listLength);

    useEffect(() => {
        updatePageNumber(pageNumber);
    }, [pageNumber])

    const paginationItems = [];

    for (let i = 1; i <= numPages; i++) {
        paginationItems.push(<li className="page-item" key={i}><a className="page-link" onClick={(e) => setPageNumber(Number(e.currentTarget.innerHTML))}>{i}</a></li>)
    }

    const trySetPageNumber = (value) => {
        if (value < 1 || value > numPages) {
            return;
        }
        setPageNumber(value)
    };

    return (
        <nav>
            <ul className="pagination pagination-sm justify-content-center">
                <li className="page-item"><a className="page-link" onClick={() => trySetPageNumber(pageNumber - 1)}>Prev</a></li>
                {paginationItems}
                <li className="page-item"><a className="page-link" onClick={() => trySetPageNumber(pageNumber + 1)}>next</a></li>
            </ul>
        </nav>
    )
}

const Transactions = () => {
    const [contractTransactionsList, setContractTransactionsList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const [shownTransactionsList, setShownTransactionsList] = useState([]);

    const numPages = getNumPages(contractTransactionsList.length);

    useEffect(() => {
        setIsError(false)
        async function getContractUpdates () {
            setIsLoading(true);
            const { data } = await api.get('api//v1/transactions/contracts').catch(() => {
                setIsError(true);
                return { data: [] };
            });
            setContractTransactionsList(data);
            setIsLoading(false);
        }

        getContractUpdates();
    }, []);

    // update shown list anytime "master" lists are updated
    useEffect(() => {
        setShownTransactionsList(contractTransactionsList.slice(0, NUM_RESULTS_PER_PAGE));
    }, [contractTransactionsList]);

    const updatePageNumber = (pageNumber) => {
        setShownTransactionsList(contractTransactionsList.slice(NUM_RESULTS_PER_PAGE * (pageNumber - 1), NUM_RESULTS_PER_PAGE * pageNumber))
    };

    return (
        <>
            <h2>Transactions</h2>
            {isError ? 'something went wrong!' : isLoading ? <Loader/> : 
                <>
                    <ul>
                        {shownTransactionsList.map(({ time, username, name: playerName, contract}) => (
                            <li key={time}>
                                {`${new Date(Number(time)).toLocaleString()} - ${username} updated ${playerName} to ${contract} years`}
                            </li>
                        ))}
                    </ul>
                    <Pagination listLength={contractTransactionsList.length} updatePageNumber={updatePageNumber}/>
                </>
            }
        </>
    )
};

export default Transactions;